import { render, staticRenderFns } from "./ViNavBar.vue?vue&type=template&id=10c56121"
import script from "./ViNavBar.vue?vue&type=script&lang=js"
export * from "./ViNavBar.vue?vue&type=script&lang=js"
import style0 from "./ViNavBar.vue?vue&type=style&index=0&id=10c56121&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports